import React from "react";
import Table from "../Table";
import moment from "moment";

const title = "Webhook Details";
const columns = [
  {
    name: "Application Id",
    selector: "payload.applicationId",
    sortable: false,
    maxWidth: "20%"
  },
  {
    name: "Login Name",
    selector: "payload.loginName",
    sortable: false,
    maxWidth: "300px",
    cell: row => {
      return <span title={row.payload.loginName}>{row.payload.loginName}</span>;
    }
  },
  {
    name: "Status",
    selector: "payload.status",
    sortable: false,
    maxWidth: "10%"
  },
  {
    name: "Submission Date",
    selector: "payload.submissionDate",
    sortable: true,
    ignoreRowClick: true,
    maxWidth: "14%",
    cell: row => {
      return (
        <span>
          {moment
            .utc(row.payload.submissionDate)
            .local()
            .format("MM-DD-YYYY HH:mm")}
        </span>
      );
    }
  },
  {
    name: "Completion Date",
    selector: "payload.completionDate",
    sortable: true,
    ignoreRowClick: true,
    maxWidth: "14%",
    center: true,
    cell: row => {
      return (
        (row.payload.completionDate && (
          <span>
            {moment
              .utc(row.payload.completionDate)
              .local()
              .format("MM-DD-YYYY HH:mm")}
          </span>
        )) || <span>NA</span>
      );
    }
  },
  {
    name: "Dispatch Time",
    selector: "payload.timeStamp",
    sortable: true,
    ignoreRowClick: true,
    maxWidth: "14%",
    cell: row => {
      return (
        <span>
          {moment
            .utc(row.payload.timeStamp)
            .local()
            .format("MM-DD-YYYY HH:mm")}
        </span>
      );
    }
  }
];

function WebhookTable(props) {
  console.log(props.data);
  return (
    <Table
      title={title}
      columns={columns}
      data={props.data}
      pagination={false}
    />
  );
}

export default WebhookTable;
